import { Avatar, Button } from "antd";
import React from "react";
import { IoCall } from "react-icons/io5";
import mapImage from "../Images/map.png";

export default function ContactForm({ VenuesDetails }) {
  return (
    <div
      className="details-section d-md-flex justify-content-between align-items-center"
      style={{
        boxShadow: "0 0 10px 0 rgba(0,0,0,0.1)",
        background: "white",
        padding: "30px 20px",
        borderRadius: 10,
        marginTop: 20,
      }}
    >
      <div className="details d-flex align-items-center">
        <Avatar size={50} src={mapImage} style={{ marginRight: 10 }} />{" "}
        <strong style={{ fontSize: 18 }}>
          Would you like to schedule a visit?
        </strong>
      </div>
      <Button
        style={{
          backgroundColor: "maroon",
          color: "white",
          borderRadius: 0,
          height: 40,
        }}
        icon={<IoCall />}
        className="mt-3 mt-md-0"
      >
        Request a Quote
      </Button>
    </div>
  );
}
